<template>
  <b-row class="navbar-container">
    <b-card class="col-12">
      <b-col cols="12">
         <iframe
              :src="`https://ocpbconnect.ocpb.go.th/ReportMobile?report_id=1C961F8C-E319-4FD0-83F4-B8E617344BAB`"
              width="100%"
              height="1000"
              frameborder="0" >
            </iframe>
      </b-col>
    </b-card>
  </b-row>
</template>

<script>
import { BRow, BCol, BTabs, BTab, BButton, BCard, BCardHeader, BCardBody, } from "bootstrap-vue";
import appsettings from "@/store/app-settings";
export default {
  components: {
   BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
  },
  data() {
    return {
      data: { },
    }
  },
  created() {
    
  },
}
</script>

<style>
</style>
